import React from 'react';

// DEPENDENCIES
import isFunction from 'lodash/isFunction';
import { useLocation } from 'react-router-dom';

// REACT ROUTER COMPONENTS
import { Link } from 'react-router-dom';

// MAIN COMPONENT
const LinkCell = ({
  row: { original } = {},
  value,
  children = value,
  column: { to: columnTo } = {},
  to: toProp = columnTo,
  placeholder
}) => {
  const to = isFunction(toProp) ? toProp(value, original) : toProp;
  const location = useLocation();

  // RENDER
  return children
    ? <Link
        to={to}
        state={{
          prevPath: location.pathname,
          queryParams: location.state?.queryParams
        }}>
          {children}
      </Link>
    : placeholder;
};

// EXPORT
export default LinkCell;
